import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  styled,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@hooks/useStore';
import { selectActiveDirectory } from '@features/files/filesSlice';
import { getSizeFormat } from '@utils/getSizeFormat';

const UploadCompleteModal = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const UploadCompleteDialogTittle = styled(DialogTitle)({
  height: 30,
  backgroundColor: '#025EF9',
  color: 'white',
  display: 'flex'
});

const UploadCompleteGrid = styled(Grid)({
  marginTop: '25px'
});

const UploadCompleteMessage = styled(Typography)({
  color: '#183857',
  textAlign: 'center',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: 21,
  wordWrap: 'break-word'
});

const CloseButton = styled(IconButton)({
  marginLeft: 'auto',
  width: 17.5,
  height: 18
});

interface UploadCompleteProps {
  show: boolean;
  closeSuccessModal: () => void;
  message?: string;
  closable?: boolean;
  onRefresh: () => void;
  filesLength?: number;
  totalSize?: number;
}

const UploadCompleteDialog = ({
  show,
  closeSuccessModal,
  closable,
  message,
  filesLength,
  onRefresh,
  totalSize
}: UploadCompleteProps) => {
  const { t } = useTranslation();
  const { name: folderName } = useAppSelector(selectActiveDirectory);
  return (
    <UploadCompleteModal open={show}>
      <UploadCompleteDialogTittle sx={{ p: 1 }}>
        <img
          src="/img/heirloom_main_logo_icon.svg"
          alt="icon"
          width={17}
          height={17}
          style={{ marginRight: '5px' }}
        />
        <Typography>{t('titles.heirloom-title')}</Typography>
        {closable && (
          <CloseButton
            aria-label="close"
            onClick={() => {
              onRefresh();
              closeSuccessModal();
            }}
          >
            <CloseIcon />
          </CloseButton>
        )}
      </UploadCompleteDialogTittle>
      <DialogContent sx={{ height: 174 }}>
        {filesLength && filesLength > 0 ? (
          <UploadCompleteGrid container spacing={2} flexDirection="column">
            <Grid item flexGrow={1}>
              <UploadCompleteMessage>
                {t('home.uploadingComplete', {
                  filesSize: filesLength,
                  folderName
                })}
              </UploadCompleteMessage>
            </Grid>
            {!!totalSize && (
              <Grid item flexGrow={1}>
                <UploadCompleteMessage>{getSizeFormat(totalSize)}</UploadCompleteMessage>
              </Grid>
            )}
          </UploadCompleteGrid>
        ) : (
          <UploadCompleteMessage>{message}</UploadCompleteMessage>
        )}
      </DialogContent>
    </UploadCompleteModal>
  );
};

export default UploadCompleteDialog;
